import { retrieveDefaultCodes } from '../../../components/SearchForm/components/AirportsWidget/utils/config.js';
import { getDefaultValues as getDefaultTravelPeriodValues } from '../../../components/SearchForm/hooks/useDefaultTravelPeriodValues/utils.js';
export const getDefaultValues = ({
  airports,
  travelPeriod
}) => {
  return {
    destination: null,
    airports: retrieveDefaultCodes(airports),
    travelPeriod: getDefaultTravelPeriodValues(travelPeriod),
    travellers: {
      adultCount: 2,
      childrenAges: []
    },
    travellersMultiroom: {
      adultsCount: 2,
      childrenCount: 0,
      rooms: [{
        adultsCount: 2,
        childrenAges: []
      }]
    }
  };
};